module.exports = __webpack_public_path__ + "static/media/importFlybook1.52d01ce3.png";